import React, { useState, useContext, useEffect } from 'react';
import { Helper } from 'utils';
import { Api } from 'services';
import { AppActions} from 'store';
import { DispatchContext } from 'context';
import './paquetes.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { withRouter, useLocation } from "react-router-dom";
import { useSnackbar } from 'notistack';
import { TextField } from '@mui/material';

// Importa el componente y los estilos de react-image-gallery
import ImageGallery from 'react-image-gallery';
import 'react-image-gallery/styles/css/image-gallery.css';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { SocialShare } from 'components/socialshare';

const Destino = (props) => {
    const { enqueueSnackbar } = useSnackbar();
    const dispatch = useContext(DispatchContext);
    // const state = useContext(StateContext);
    // const indexTema = state && state.appReducer && state.appReducer.indexTema ? state.appReducer.indexTema : 0;
    const [destino, setDestino] = useState(null);
    const [msgEnvioExitoso, setMsgEnvioExitoso] = useState("");
    const [imagenes, setImagenes] = useState([]); 
    const [descripcion, setDescripcion] = useState(false);
    const [isLoadingDescripcion, setIsLoadingDescripcion] = useState(true);
    const location = useLocation();
    
    const [data, setData] = useState({
        pe_nombre: "",
        pe_celular: "",
        pe_email: "",
        pe_mensaje: ""
    });
    const [errores, setErrores] = useState({
        pe_nombre: false,
        pe_celular: false,
        pe_email: false,
        pe_mensaje: false
    });
    // const [modelo, setModelo] = useState({
    //     pe_nombre: "",
    //     pe_celular: "",
    //     pe_email: "",
    //     pe_mensaje: ""
    // });

    const modeloInicial = {
        pe_nombre: "",
        pe_celular: "",
        pe_email: "",
        pe_mensaje: ""
    };
    // Nuevo estado para controlar el envío
    const [isSending, setIsSending] = useState(false);

    const getDestino = () => {
        dispatch(AppActions.setLoading(true));
        dispatch(AppActions.setActionsDisabled(true));
        var options = {
            url: Api.route('/paquetes_imagen/listar/'+props.match.params.id),
            method: 'GET'
        };
        Api.request(options, response => {
            Helper.log('getModeloEmailAgente response', response);
            dispatch(AppActions.setLoading(false));
            dispatch(AppActions.setActionsDisabled(false));
            if (response.codigo && response.codigo !== 200) {
                enqueueSnackbar(response.mensaje, { variant: 'error' });
            } else if (response.codigo && response.codigo === 200) {
                setDestino(response.datos);
                const formattedImages = response.datos.map(img => ({
                                    original: Api.route('/imagenes/ver/' + img.idimagen + '/1280/1280'),
                                    thumbnail: Api.route('/imagenes/ver/' + img.idimagen + '/200/200')
                                })).reverse();
                                setImagenes(formattedImages);
            }
        }, error => {
            Helper.log('error getModeloEmailAgente', error);
            dispatch(AppActions.setLoading(false));
            dispatch(AppActions.setActionsDisabled(false));
        });
    }

    const getDescripcion = () => {
        dispatch(AppActions.setLoading(true));
        dispatch(AppActions.setActionsDisabled(true));
        setIsLoadingDescripcion(true);
        var options = {
            url: Api.route('/paquetes/buscar/'+props.match.params.id),
            method: 'GET'
        };
        Api.request(options, response => {
            Helper.log('getModeloEmailAgente response', response);
            dispatch(AppActions.setLoading(false));
            dispatch(AppActions.setActionsDisabled(false));
            setIsLoadingDescripcion(false);
            if (response.codigo && response.codigo !== 200) {
                enqueueSnackbar(response.mensaje, { variant: 'error' });
            } else if (response.codigo && response.codigo === 200) {
                setDescripcion(response.datos);
            }
        }, error => {
            Helper.log('error getModeloEmailAgente', error);
            dispatch(AppActions.setLoading(false));
            dispatch(AppActions.setActionsDisabled(false));
            setIsLoadingDescripcion(false);
        });
    }

    useEffect(() => {
        getDestino();
        getDescripcion();
    }, []);

    useEffect(() => {
       // if (descripcion === false || (descripcion && descripcion.idestadopublicacion !== 4)) {
        if (!isLoadingDescripcion && (descripcion === false || (descripcion && descripcion.idestadopublicacion !== 4))) {
            const timer = setTimeout(() => {
                window.location.href = '/';
            }, 1250);
            
            return () => clearTimeout(timer);
        }
    }, [descripcion, isLoadingDescripcion]);


    const onChangeForm = (event, campo) => {
        setData({
            ...data,
            [campo]: event.target.value
        });
        setErrores({
            ...errores,
            [campo]: false
        });
    }
    const enviarEmailAgente = () => {
        if (isSending) return; // Previene múltiples clics

        const { pe_nombre, pe_celular, pe_email, pe_mensaje } = data;
        let todoBien = true;
        let errors = {
            pe_nombre: false,
            pe_celular: false,
            pe_email: false,
            pe_mensaje: false
        };
        if (pe_nombre && pe_nombre !== "") {
            // datos.pe_nombre = pe_nombre;
        } else {
            todoBien = false;
            errors.pe_nombre = true;
        }
        if (pe_celular && pe_celular !== "") {
            // datos.pe_celular = pe_celular;
        } else {
            todoBien = false;
            errors.pe_celular = true;
        }
        if (pe_email && pe_email !== "" && Helper.validateEmail(pe_email)) {
            // datos.pe_email = pe_email;
        } else {
            todoBien = false;
            errors.pe_email = true;
        }
        if (pe_mensaje && pe_mensaje !== "") {
            // datos.pe_mensaje = pe_mensaje;
        } else {
            todoBien = false;
            errors.pe_mensaje = true;
        }
        console.log('todoBien', todoBien);
        console.log('errores', errors);
        console.log('data', data);
        setErrores(errors);
        if (todoBien) {
            setIsSending(true); // Se establece el estado de envío a true
            dispatch(AppActions.setLoading(true));
            dispatch(AppActions.setActionsDisabled(true));
            const datosParaEnviar = {
                ...data,
                idreferencia: descripcion ? descripcion.idpaquete : null,
                idestadoemail: 0,
                idpaq_email: 0,
                idorigen: 0,
                idusuario: 0,
                pe_fecha: '',
                pe_fecha_respuesta: '',
                pe_obs: '',
                pe_respuesta: ''
                
            };
            var options = {
                url: Api.route('/paquetes_email/guardar'),
                method: 'POST',
                data: datosParaEnviar
            };
            Api.request(options, response => {
                Helper.log('enviarEmailAgente response', response);
                dispatch(AppActions.setLoading(false));
                dispatch(AppActions.setActionsDisabled(false));
                setIsSending(false); // Se establece el estado de envío a false
                if (response.codigo && response.codigo !== 200) {
                    enqueueSnackbar(response.mensaje, { variant: 'error' });
                } else if (response.codigo && response.codigo === 200) {
                    setData(modeloInicial);
                    setMsgEnvioExitoso("Hemos recibido tu mensaje, gracias por comunicarte con nosotros");
                    setTimeout(() => {
                        setMsgEnvioExitoso("");
                    }, 6000);
                }
            }, error => {
                Helper.log('error enviarEmailAgente', error);
                dispatch(AppActions.setLoading(false));
                dispatch(AppActions.setActionsDisabled(false));
                setIsSending(false); // Se establece el estado de envío a false
            });
        }
        
    }

    const currentUrl = window.location.origin + location.pathname ;
    const title = "Mira este contenido Destino: " + (descripcion ? descripcion.paq_titulo : '');

    return (
        <>
            <div id="destino" className="w3-block bs-bbox destino-margen-superior">
                <div className="w3-content" >
            {destino ? <>
                    <div className="w3-padding">
                        <div className="w3-row">
                            <div className="w3-col l7 col-izquierda" style={{ position: 'relative' }}>
                                {imagenes.length > 1 ? (
                                    <ImageGallery 
                                        items={imagenes} 
                                        showPlayButton={false} 
                                        showFullscreenButton={true} 
                                        thumbnailPosition="bottom"
                                        autoPlay={true}
                                        slideInterval={5000}
                                    />
                                    ) : imagenes.length === 1 ? (
                                            <img className="cursor-pointer w3-block" src={imagenes[0].original} alt="imagen-paquete-principal" />
                                    ) : (
                                        // Mostrar un placeholder cuando no hay imágenes
                                        <div style={{
                                            width: '100%',
                                            height: '400px',
                                            backgroundColor: '#f0f0f0',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                        }}>
                                            <span style={{ color: '#999' }}></span>
                                        </div>
                                    )}
                                
                                {/* Overlay cuando el destino no está disponible o no existe */}
                                {!isLoadingDescripcion && (!descripcion || (descripcion && descripcion.idestadopublicacion !== 4)) && (
                                    <div style={{
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        right: 0,
                                        bottom: 0,
                                        backgroundColor: 'rgba(0, 0, 0, 0.7)',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        zIndex: 1000
                                    }}>
                                        <div style={{
                                            color: 'white',
                                            fontSize: '2rem',
                                            fontWeight: 'bold',
                                            textAlign: 'center',
                                            padding: '20px'
                                        }}>
                                            Destino no disponible
                                        </div>
                                    </div>
                                )}
                            </div>
                            <div className="w3-row titulo-precio  w3-hide-large"   >
                            <div className="w3-col ">
                                <h2 >{descripcion.paq_titulo}</h2>
                                {/* <span style={{ color: Themes[indexTema].D5 }}>{Helper.formatearNumero(destino.paq_precio)} U$D</span> */}
                                <p>{descripcion.paq_contenido}</p>
                                <hr />
                            </div>
                        </div>
                            <div className="w3-col l5 col-derecha">
                                <div className="contact-form-container">
                                    <h3 style={{margin: 0}}className="w3-color-theme-d4">Contacte con uno de nuestros agentes de viaje</h3>
                                    <br />
                                    <TextField
                                        label="Nombre/Apellido"
                                        id="input-nombre"
                                        size="small"
                                        className="w3-block"
                                        margin="normal"
                                        value={data.pe_nombre}
                                        error={errores.pe_nombre}
                                        onChange={event => onChangeForm(event, 'pe_nombre')}
                                        
                                    /><br />
                                    <TextField
                                        label="Celular"
                                        id="input-celular"
                                        size="small"
                                        className="w3-block"
                                        margin="normal"
                                        value={data.pe_celular}
                                        error={errores.pe_celular}
                                        onChange={event => onChangeForm(event, 'pe_celular')}
                                        
                                    /><br />
                                    <TextField
                                        label="Email"
                                        id="input-email"
                                        size="small"
                                        className="w3-block"
                                        margin="normal"
                                        value={data.pe_email}
                                        error={errores.pe_email}
                                        onChange={event => onChangeForm(event, 'pe_email')}
                                        
                                    /><br />
                                    <TextField
                                        label="Mensaje"
                                        id="input-mensaje"
                                        size="small"
                                        className="w3-block"
                                        margin="normal"
                                        value={data.pe_mensaje}
                                        error={errores.pe_mensaje}
                                        onChange={event => onChangeForm(event, 'pe_mensaje')}
                                        multiline
                                        rows={4}
                                        inputProps={{ maxLength: 450 }}
                                        helperText={`${data.pe_mensaje?.length || 0}/450`}
                                        
                                    />
                                    <br />
                                    <button 
                                        className="w3-btn w3-block w3-light-gray w3-border w3-large w3-round w3-margin-top" 
                                        onClick={() => enviarEmailAgente()}
                                        disabled={isSending} // Deshabilita el botón mientras se envía
                                    >
                                        {isSending ? 'Enviando...' : 'Enviar'} {/* Muestra "Enviando..." cuando isSending es true */}
                                    </button>
                                    <a 
                                        className="w3-btn w3-block w3-green w3-large w3-round w3-margin-top" 
                                        style={{padding: '8px 0'}}
                                        href={"https://wa.me/595981490073?text=Hola,%20quiero%20más%20información%20sobre%20el%20destino%20"+descripcion.paq_titulo+"%20("+descripcion.idpaquete+")"}
                                        
                
                                    >
                                        <FontAwesomeIcon icon={faWhatsapp} aria-hidden="true" title="whatsapp" /> &nbsp;
                                        Contactanos
                                    </a>
                                    <SocialShare url={currentUrl} title={title} />
                                    {msgEnvioExitoso ? <p className="w3-text-black">{msgEnvioExitoso}</p> : null}
                                </div>
                            </div>
                        </div>
                        {/* Movido la información del paquete después del formulario, dentro de un contenedor separado */}
                    
                        <div className="w3-row titulo-precio w3-hide-small w3-hide-medium"   >
                            <div className="w3-col ">
                                <h2 >{descripcion.paq_titulo}</h2>
                                {/* <span style={{ color: Themes[indexTema].D5 }}>{Helper.formatearNumero(destino.paq_precio)} U$D</span> */}
                                <p>{descripcion.paq_contenido}</p>
                                <hr />
                            </div>
                        </div>
                    </div>
                </> : null}
                </div>
            </div>
        </>
    );
}

export default withRouter(Destino);